<div class="page-container">
    <div class="page-header">
        <div class="header-content">
            <h1 class="page-title">Customer Settings</h1>
            <p class="page-subtitle">Manage customer-related configuration options</p>
        </div>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="loading-overlay">
        <mat-spinner diameter="50" color="primary"></mat-spinner>
        <p class="loading-text">Loading settings...</p>
    </div>

    <div class="settings-grid" [class.loading]="isLoading">
        <!-- Business Type -->
        <div class="setting-card">
            <div class="card-header">
                <div class="header-icon">
                    <mat-icon>business</mat-icon>
                </div>
                <div class="header-text">
                    <h3 class="card-title">Business Type</h3>
                    <p class="card-subtitle">Define customer business categories</p>
                </div>
            </div>

            <div class="card-body">
                <div class="input-row">
                    <input
                        class="modern-input"
                        type="text"
                        [formControl]="searchControl"
                        placeholder="Enter business type"
                        (keyup.enter)="addBusinessType()" />
                    <button
                        (click)="addBusinessType()"
                        type="button"
                        class="btn-add">
                        <mat-icon>add</mat-icon>
                        <span>Add</span>
                    </button>
                </div>

                <div class="items-grid" *ngIf="businessTypes.length > 0">
                    <div *ngFor="let item of businessTypes" class="item-chip">
                        <span class="item-name">{{ item.name }}</span>
                        <button type="button" class="btn-remove" (click)="removeBusinessType(item)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </div>

                <div *ngIf="businessTypes.length === 0" class="empty-state">
                    <mat-icon>inventory_2</mat-icon>
                    <p>No business types added yet</p>
                </div>
            </div>
        </div>

        <!-- Credit Terms -->
        <div class="setting-card">
            <div class="card-header">
                <div class="header-icon">
                    <mat-icon>receipt_long</mat-icon>
                </div>
                <div class="header-text">
                    <h3 class="card-title">Credit Terms</h3>
                    <p class="card-subtitle">Define credit payment terms</p>
                </div>
            </div>

            <div class="card-body">
                <div class="input-row">
                    <input
                        class="modern-input"
                        type="text"
                        [formControl]="searchControl"
                        placeholder="Enter credit term"
                        (keyup.enter)="addCreditTerms()" />
                    <button
                        (click)="addCreditTerms()"
                        type="button"
                        class="btn-add">
                        <mat-icon>add</mat-icon>
                        <span>Add</span>
                    </button>
                </div>

                <div class="items-grid" *ngIf="creditTerms.length > 0">
                    <div *ngFor="let item of creditTerms" class="item-chip">
                        <span class="item-name">{{ item.name }}</span>
                        <button type="button" class="btn-remove" (click)="removeCreditTerms(item)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </div>

                <div *ngIf="creditTerms.length === 0" class="empty-state">
                    <mat-icon>inventory_2</mat-icon>
                    <p>No credit terms added yet</p>
                </div>
            </div>
        </div>

        <!-- Financial Rating -->
        <div class="setting-card">
            <div class="card-header">
                <div class="header-icon">
                    <mat-icon>star_rate</mat-icon>
                </div>
                <div class="header-text">
                    <h3 class="card-title">Financial Rating</h3>
                    <p class="card-subtitle">Customer financial ratings</p>
                </div>
            </div>

            <div class="card-body">
                <div class="input-row">
                    <input
                        class="modern-input"
                        type="text"
                        [formControl]="searchControl"
                        placeholder="Enter financial rating"
                        (keyup.enter)="addFinancialRating()" />
                    <button
                        (click)="addFinancialRating()"
                        type="button"
                        class="btn-add">
                        <mat-icon>add</mat-icon>
                        <span>Add</span>
                    </button>
                </div>

                <div class="items-grid" *ngIf="financialRatings.length > 0">
                    <div *ngFor="let item of financialRatings" class="item-chip">
                        <span class="item-name">{{ item.name }}</span>
                        <button type="button" class="btn-remove" (click)="removeFinancialRating(item)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </div>

                <div *ngIf="financialRatings.length === 0" class="empty-state">
                    <mat-icon>inventory_2</mat-icon>
                    <p>No ratings added yet</p>
                </div>
            </div>
        </div>
    </div>
</div>
